var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C12.1929 4 12.3779 4.07662 12.5143 4.21301C12.6506 4.3494 12.7273 4.53439 12.7273 4.72727V11.2727H19.2727C19.4656 11.2727 19.6506 11.3494 19.787 11.4857C19.9234 11.6221 20 11.8071 20 12C20 12.1929 19.9234 12.3779 19.787 12.5143C19.6506 12.6506 19.4656 12.7273 19.2727 12.7273H12.7273V19.2727C12.7273 19.4656 12.6506 19.6506 12.5143 19.787C12.3779 19.9234 12.1929 20 12 20C11.8071 20 11.6221 19.9234 11.4857 19.787C11.3494 19.6506 11.2727 19.4656 11.2727 19.2727V12.7273H4.72727C4.53439 12.7273 4.3494 12.6506 4.21301 12.5143C4.07662 12.3779 4 12.1929 4 12C4 11.8071 4.07662 11.6221 4.21301 11.4857C4.3494 11.3494 4.53439 11.2727 4.72727 11.2727H11.2727V4.72727C11.2727 4.53439 11.3494 4.3494 11.4857 4.21301C11.6221 4.07662 11.8071 4 12 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.30297296818f87b0ac499f1fe6bb40fa.svg";
export { ForwardRef as ReactComponent };